$(document).ready(function() {

  $('.btn-toggle').on('click', function() {
    var collapseText = $(this).data('collapse-text');
    var uncollapseText = $(this).data('uncollapse-text');
    var text = $(this).text();
    $(this).text(
      text == collapseText ? uncollapseText : collapseText);
  });

})